module.exports = __webpack_public_path__ + "static/media/graphic-no-prospect.8f011b0f.png";